import { getIsLoggedIn } from '@account/entity';
import { getLoginUrl } from '@account/utils';
import { getSiteContext } from '@analytics/utils';
import { Component, HostBinding, inject } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import {
  getBrandLogoLinkUrl,
  getLanguage,
  getMainNavigation,
  getServiceNavigationRootName,
  getShowNavigation,
  getSitecoreContextWithStatus,
  getTopNavigation,
  JssRouteBuilderService,
} from '@core/jss-routing';
import {
  getSettingsObject,
  getSettingsValue,
  login,
  loginUrl,
  myEnvironmentActive,
} from '@core/settings';
import { ActiveLinkService, showCategories } from '@core/navigation-store';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

import { StickyHeaderComponent } from '../sticky-header.component';

@Component({
  selector: 'wl-sticky-header-container',
  templateUrl: './sticky-header-container.component.html',
  standalone: true,
  imports: [StickyHeaderComponent, AsyncPipe],
})
export class StickyHeaderContainerComponent {
  @HostBinding('class')
  class = 'd-block sticky-top';

  readonly #store$ = inject(Store);
  public language$ = this.#store$.pipe(select(getLanguage));
  public readonly isLoggedIn$ = this.#store$.pipe(select(getIsLoggedIn));
  public openNavigation$ = this.#store$.select(
    getSettingsObject('navigation', 'OpenNavigationItem')
  );
  public serviceNavigationLink$ = this.#store$.pipe(select(loginUrl));
  public serviceNavigationTitle$ = this.#store$.pipe(
    getServiceNavigationRootName
  );
  public mainNavigationTitle$ = this.#store$.pipe(
    select(getSettingsValue('navigation', 'MainNavigationTitle'))
  );
  public brandLogoLinkUrl$ = this.#store$.select(getBrandLogoLinkUrl);
  public loginUrlLabel$ = this.#store$.pipe(select(login));
  public showNavigation$ = this.#store$.select(getShowNavigation);
  readonly #urlBuilder = inject(JssRouteBuilderService);
  readonly #activeLinkService = inject(ActiveLinkService);
  public showCategories$ = this.#store$.pipe(
    showCategories(this.#store$, this.#urlBuilder, this.#activeLinkService)
  );
  readonly #config = inject(ENVIRONMENT_CONFIG);
  public loginUrl? = getLoginUrl(this.#config);
  public placement$ = getSiteContext(this.#store$, this.#config);
  private readonly mainNavigationInfo$ = this.#store$.pipe(getMainNavigation);
  public isMainNavigationAvailable$ = this.mainNavigationInfo$.pipe(
    map((info) => info.isNavigationAvailable)
  );
  public mainNavigationItems$ = this.mainNavigationInfo$.pipe(
    map((info) => info.navItems)
  );
  private readonly topNavigationInfo$ = this.#store$.pipe(getTopNavigation);
  public isTopNavigationAvailable$ = this.topNavigationInfo$.pipe(
    map((info) => info.isNavigationAvailable)
  );
  public topNavigationItems$ = this.topNavigationInfo$.pipe(
    map((info) => info.navItems)
  );
  private readonly myEnvironmentActive$ = this.#store$.pipe(
    select(myEnvironmentActive)
  );
  private readonly hasContext$ = this.#store$.pipe(
    getSitecoreContextWithStatus,
    map((context) => context != null)
  );
  public readonly serviceNavigationActive$ = combineLatest([
    this.myEnvironmentActive$,
    this.hasContext$,
    this.isLoggedIn$,
  ]).pipe(
    map(
      ([active, hasContext, isLoggedIn]) => active && hasContext && isLoggedIn
    )
  );
}
